import * as types from "./CommonActionTypes";
import { updateCostCenterCountryInSessionStorage } from "../auth/persistance";

export const openProfileSidePanel = () => ({
	type: types.OPEN_PROFILE
});

export const openBookmarksSidePanel = () => ({
	type: types.OPEN_BOOKMARKS
});

export const closeProfileSidePanel = () => ({
	type: types.CLOSE_PROFILE
});

export const closeBookmarksSidePanel = () => ({
	type: types.CLOSE_BOOKMARKS
});

export const refreshBookmarks = refreshBookmarks => ({
	type: types.REFRESH_BOOKMARKS,
	refreshBookmarks
});

const setGlobalFilters = (data) => ({
  type: types.SET_GLOBAL_FILTERS,
  data
});

// Update the cost center and country in local storage
export const setGlobalCountryCostCenter = (data) => {
	updateCostCenterCountryInSessionStorage(data);
	return dispatch => {
		dispatch(setGlobalFilters(data));
	};
};

export const setGlobalDynamicFilter = data => ({
	type: types.SET_GLOBAL_DYNAMIC_FILTERS,
	data
});



// WEBPACK FOOTER //
// ./src/action/CommonActions.js